module.exports = __webpack_public_path__ + "pc/img/appdown.bbcc4385.png";